export default __webpack_public_path__ + "static/media/orioir-coupon.167f00c1.png";